import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { cx } from '@mage-ui/styled-system/css';
import {
  bordersWrapper,
  courseSection,
  gridCol,
  gridRow,
} from '@mage-ui/styled-system/recipes';
import { useContext } from 'react';
import { GoToCta } from '../../navigation/ctas/GoToCta';
import { GridCol } from '../grids/GridCol';
import { GridRow } from '../grids/GridRow';

export const CourseSection = ({
  filterTop,
  filterMid,
  filterBottom,
  children,
  anchor,
  sectionId,
  ...props
}) => {
  const { st } = useContext(StaticTextContext);
  return (
    <section className={courseSection().root} id={sectionId} {...props}>
      <div className={courseSection().wrapper}>
        <div className={courseSection().filtersWrapper}>
          {(filterTop || filterMid) && (
            <div className={cx(bordersWrapper(), courseSection().filters)}>
              <GridRow
                className={gridRow({
                  gap: 'gap100',
                  gapM: 'gap500',
                  gapL: 'gap500',
                })}
              >
                {filterTop && (
                  <GridCol
                    className={gridCol({ colSpanM: '6', colSpanL: '6' })}
                  >
                    {filterTop}
                  </GridCol>
                )}
                {filterMid && (
                  <GridCol
                    className={gridCol({ colSpanM: '6', colSpanL: '6' })}
                  >
                    {filterMid}
                  </GridCol>
                )}
              </GridRow>
            </div>
          )}

          {filterBottom && filterBottom}
        </div>

        <GridRow>
          <GridCol
            className={gridCol({
              colSpanL: '11',
            })}
          >
            {children}
          </GridCol>
        </GridRow>
      </div>
      <div className={courseSection().goto}>
        <GoToCta text={anchor?.text || st('body.goto')} />
      </div>
    </section>
  );
};
